import { render, staticRenderFns } from "./lgXd.vue?vue&type=template&id=7a0cb430&scoped=true&"
import script from "./lgXd.vue?vue&type=script&lang=js&"
export * from "./lgXd.vue?vue&type=script&lang=js&"
import style0 from "./lgXd.vue?vue&type=style&index=0&id=7a0cb430&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cb430",
  null
  
)

export default component.exports